//-------------MONITORING_COPY--------------
import {createSlice, PayloadAction} from "@reduxjs/toolkit";
import {AppState} from "../../App/store";
import {SelectedBooleanStatusType, SelectedDataReceivedStatusType, SelectedStormModeStatusType} from "../../Filters/utils";

export const FILTERS_SLICE_MONITORING = 'filtersMonitoring';

type FiltersSliceState = {
    stationSearchText: string,
    /** выбранные регионы (может быть либо 1 ugms либо ugms и cgms) */
    selectedRegion: {
        /** выбранный айди региона (ugms или cgms для select) */
        id: number | undefined,
        /** список регионов, по которым нужно искать (может быть либо 1 ugms либо ugms и cgms) */
        ids?: number[],
    },
    selectedType: {
        id: number | undefined
    },
    // selectedStationType
    selectedDatasourceTypesIds: number[] | undefined,

    // статусы
    selectedEnableMode: SelectedBooleanStatusType,
    selectedDangerMode: SelectedBooleanStatusType,
    selectedSoftRelease: SelectedBooleanStatusType,
    selectedDataReceived: SelectedDataReceivedStatusType,
    selectedStormMode: SelectedStormModeStatusType,
}

const initialStateMonitoring: FiltersSliceState = {
    stationSearchText: '',
    selectedRegion: {
        id: undefined,
    },
    selectedType: {
        id: undefined
    },
    selectedDatasourceTypesIds: undefined,
    selectedEnableMode: undefined,
    selectedDangerMode: undefined,
    selectedSoftRelease: undefined,
    selectedDataReceived: undefined,
    selectedStormMode: undefined,
};

const filtersSliceMonitoring = createSlice({
    name: FILTERS_SLICE_MONITORING,
    initialState : initialStateMonitoring,
    reducers: {
        setStationSearchTextMonitoring: (state, { payload }: PayloadAction<string>) => {
            state.stationSearchText = payload;
        },
        setSelectedRegionMonitoring: (state, { payload }: PayloadAction<FiltersSliceState['selectedRegion']>) => {
            state.selectedRegion = payload;
        },
        setSelectedTypeIdMonitoring: (state, { payload }: PayloadAction<FiltersSliceState['selectedType']>) => {
            state.selectedType = payload;
        },
        setSelectedDatasourceTypesIdsMonitoring: (state, { payload }: PayloadAction<FiltersSliceState['selectedDatasourceTypesIds']>) => {
            if (payload?.length) state.selectedDatasourceTypesIds = payload;
            else state.selectedDatasourceTypesIds = initialStateMonitoring.selectedDatasourceTypesIds;
        },

        setSelectedEnableModeMonitoring: (state, { payload }: PayloadAction<FiltersSliceState['selectedEnableMode']>) => {
            state.selectedEnableMode = payload;
        },
        setSelectedDangerModeMonitoring: (state, { payload }: PayloadAction<FiltersSliceState['selectedDangerMode']>) => {
            state.selectedDangerMode = payload;
        },
        setSelectedSoftReleaseMonitoring: (state, { payload }: PayloadAction<FiltersSliceState['selectedSoftRelease']>) => {
            state.selectedSoftRelease = payload;
        },
        setSelectedDataReceivedMonitoring: (state, { payload }: PayloadAction<FiltersSliceState['selectedDataReceived']>) => {
            state.selectedDataReceived = payload;
        },
        setSelectedStormModeMonitoring: (state, { payload }: PayloadAction<FiltersSliceState['selectedStormMode']>) => {
            state.selectedStormMode = payload;
        },
        resetFiltersSliceMonitoring: () => initialStateMonitoring,
    },
});

export const {
    setStationSearchTextMonitoring,
    setSelectedRegionMonitoring,
    setSelectedTypeIdMonitoring,
    setSelectedDatasourceTypesIdsMonitoring,

    setSelectedEnableModeMonitoring,
    setSelectedDangerModeMonitoring,
    setSelectedSoftReleaseMonitoring,
    setSelectedDataReceivedMonitoring,
    setSelectedStormModeMonitoring,
    resetFiltersSliceMonitoring,
} = filtersSliceMonitoring.actions;
export default filtersSliceMonitoring.reducer;

// % _______________ SELECTORS _____________

export const noFiltersSelectorMonitoring = (state:AppState) => JSON.stringify(state[FILTERS_SLICE_MONITORING]) === JSON.stringify(initialStateMonitoring);

export const stationSearchTextSelectorMonitoring = (state:AppState) => state[FILTERS_SLICE_MONITORING].stationSearchText;

export const selectedRegionIdSelectorMonitoring = (state:AppState) => {return  state[FILTERS_SLICE_MONITORING].selectedRegion.id};
export const selectedTypeIdSelectorMonitoring = (state:AppState) => {return  state[FILTERS_SLICE_MONITORING].selectedType.id};
export const selectedRegionIdsSelectorMonitoring = (state:AppState) => state[FILTERS_SLICE_MONITORING].selectedRegion.ids;

export const selectedDatasourceTypesIdsSelectorMonitoring = (state:AppState) => state[FILTERS_SLICE_MONITORING].selectedDatasourceTypesIds;

export const selectedEnableModeSelectorMonitoring = (state:AppState) => state[FILTERS_SLICE_MONITORING].selectedEnableMode;
export const selectedDangerModeSelectorMonitoring = (state:AppState) => state[FILTERS_SLICE_MONITORING].selectedDangerMode;
export const selectedSoftReleaseSelectorMonitoring = (state:AppState) => state[FILTERS_SLICE_MONITORING].selectedSoftRelease;
export const selectedDataReceivedSelectorMonitoring = (state:AppState) => state[FILTERS_SLICE_MONITORING].selectedDataReceived;
export const selectedStormModeSelectorMonitoring = (state:AppState) => state[FILTERS_SLICE_MONITORING].selectedStormMode;